var map = {
	"./dcp-gif0.gif": 9503,
	"./dcp-gif1.gif": 9980,
	"./dcp-gif2.gif": 8585,
	"./dcp-gif3.gif": 7705,
	"./dcp-gif4.gif": 5714,
	"./dcp-gif5.gif": 5667
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1628;